export default __webpack_public_path__ + "static/media/OPHIUCHUS_LOGO.f8757946.svg";